import { _handleError } from './error';
import { CommonCumulioDashboard } from '../models/dashboard.model';
import { BrowserCheckKey } from '../models/common.model';

// check browser support: svg, postMessage, flexbox
export const _browserCheck = (dashboardComponent: CommonCumulioDashboard): void => {
  let hasError = false;
  let errorMessage = '';
  const document_ = document.body || document.documentElement;
  const style = document_.style;
  const browserCheck: Record<BrowserCheckKey, boolean> = {
    svg: !!(
      'createElementNS' in document &&
      document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect
    ),
    flexbox: style.webkitFlexWrap === '' || style.flexWrap === '',
    postMessage: !!window.postMessage
  };
  const browserCheckKeys: BrowserCheckKey[] = ['svg', 'flexbox', 'postMessage'];

  for (const key of browserCheckKeys) {
    if (!browserCheck[key]) {
      hasError = true;
      dashboardComponent.browserNotSupported = dashboardComponent.browserNotSupported || [];
      dashboardComponent.browserNotSupported.push(key);
      errorMessage += `Your browser does not support: ${key}\n`;
    }
  }

  // Check browser for IE
  const ua = window.navigator.userAgent;
  const msie = ua.includes('MSIE');
  const trident = ua.includes('Trident/');

  if (msie || trident) {
    hasError = true;
    errorMessage = 'IE is not supported.';
  }

  if (hasError) {
    _handleError(errorMessage);
  }
};
